import { call, put, takeLatest } from 'redux-saga/effects';

import * as contactActions from './contactActions.js';
import { updateContactApiCall } from './contactAPI.js';

function* updateContactSaga({ payload }) {
  try {
    const { data } = yield call(updateContactApiCall, payload);
    yield put(contactActions.contactUpdateStore(data));
  } catch (error) {
    yield put(contactActions.contactUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* contactWatcher() {
  yield takeLatest(contactActions.contactUpdateRequest.type, updateContactSaga);
}
